import { useState } from "react";
import { resolveImg } from "@/lib/api";

// Layout-safe lazy image with a blur-up reveal. If `placeholder` (a tiny LQIP data URI)
// is provided, it shows blurred behind the image until the full pixels paint; otherwise
// the image fades in on load.
export function BlurImage({ src, alt = "", className = "", placeholder, style, ...rest }) {
  const [loaded, setLoaded] = useState(false);
  const hasPh = Boolean(placeholder);
  const fade = loaded ? "blur-0 opacity-100" : hasPh ? "blur-md opacity-100" : "blur-md opacity-0";
  return (
    <img
      src={resolveImg(src)}
      alt={alt}
      loading="lazy"
      decoding="async"
      onLoad={() => setLoaded(true)}
      onError={() => setLoaded(true)}
      className={`${className} transition-[filter,opacity,transform] duration-700 ease-out ${fade}`}
      style={
        hasPh && !loaded
          ? { ...style, backgroundImage: `url(${placeholder})`, backgroundSize: "cover", backgroundPosition: "center" }
          : style
      }
      {...rest}
    />
  );
}
